// import { Box, LinearProgress, Typography } from "@mui/material";

// const StorageUsageWidget = ({ fsUserProfile }) => {
//   console.log("fsUserProfile = ", fsUserProfile);
//   if (!fsUserProfile || !fsUserProfile.usedSpace) {
//     return null; // Don't render if data isn't available
//   }

//   // Constants
//   const TOTAL_SPACE_GB = 5;
//   const BYTES_IN_GB = 1073741824; // 1024^3
//   const BYTES_IN_MB = 1048576; // 1024^2
//   const BYTES_IN_KB = 1024;

//   // Format bytes to appropriate scale
//   const formatStorage = (bytes) => {
//     if (bytes >= BYTES_IN_GB) {
//       return `${(bytes / BYTES_IN_GB).toFixed(2)} GB`;
//     }
//     if (bytes >= BYTES_IN_MB) {
//       return `${(bytes / BYTES_IN_MB).toFixed(2)} MB`;
//     }
//     if (bytes >= BYTES_IN_KB) {
//       return `${(bytes / BYTES_IN_KB).toFixed(2)} KB`;
//     }
//     return `${bytes} bytes`;
//   };

//   // Format total space (always in GB)
//   const formatTotalSpace = (gb) => {
//     return `${gb} GB`;
//   };

//   // Calculations
//   const usedGB = fsUserProfile.usedSpace / BYTES_IN_GB;
//   const percentageUsed = (usedGB / TOTAL_SPACE_GB) * 100;

//   // eslint-disable-next-line no-unused-vars
//   // const remainingBytes = (TOTAL_SPACE_GB * BYTES_IN_GB) - fsUserProfile.usedSpace;

//   console.log("percentageUsed - ", percentageUsed);

//   return (
//     <Box sx={{ width: "100%", p: 2 }}>
//       <Box display="flex" justifyContent="space-between" mb={1}>
//         <Typography variant="body2" color="text.secondary">
//           {formatStorage(fsUserProfile.usedSpace)} of{" "}
//           {formatTotalSpace(TOTAL_SPACE_GB)} used
//         </Typography>
//         <Typography variant="body2" color="text.secondary">
//           {percentageUsed.toFixed(2)}%
//         </Typography>
//       </Box>

//       <LinearProgress
//         variant="determinate"
//         value={percentageUsed}
//         sx={{
//           height: 8,
//           borderRadius: 4,
//           "& .MuiLinearProgress-bar": {
//             borderRadius: 4,
//             backgroundColor:
//               percentageUsed > 90 ? "error.main" : "primary.main",
//           },
//         }}
//       />

//       <Typography
//         variant="caption"
//         color="text.secondary"
//         mt={1}
//         display="block"
//       >
//         {/* {formatStorage(remainingBytes)} remaining */}
//       </Typography>
//     </Box>
//   );
// };

// export default StorageUsageWidget;

// dynamic space
// import { Box, LinearProgress, Typography } from "@mui/material";

// const StorageUsageWidget = ({ userTotalSpacePlan, fsUserProfile }) => {
//   console.log("fsUserProfile = usedSpace", fsUserProfile?.usedSpace);

//   if (!fsUserProfile || !fsUserProfile.usedSpace || !userTotalSpacePlan) {
//     return null; // Don't render if data isn't available
//   }

//   const BYTES_IN_GB = 1073741824; // 1024^3
//   const BYTES_IN_MB = 1048576;
//   const BYTES_IN_KB = 1024;

//   const noOfAllowed = userTotalSpacePlan?.noOfAllowed ?? 0;
//   const format = userTotalSpacePlan?.format ?? "GB";
//   const isUnlimited = userTotalSpacePlan?.isUnlimited ?? false;

//   let TOTAL_SPACE_GB = 0;
//   let percentageUsed = 0;

//   if (!isUnlimited) {
//     TOTAL_SPACE_GB =
//       format === "TB" ? noOfAllowed * 1024 : format === "GB" ? noOfAllowed : 0;

//     const usedGB = fsUserProfile.usedSpace / BYTES_IN_GB;
//     percentageUsed = (usedGB / TOTAL_SPACE_GB) * 100;
//   }

//   // Format bytes to appropriate scale
//   const formatStorage = (bytes) => {
//     if (bytes >= BYTES_IN_GB) return `${(bytes / BYTES_IN_GB).toFixed(2)} GB`;
//     if (bytes >= BYTES_IN_MB) return `${(bytes / BYTES_IN_MB).toFixed(2)} MB`;
//     if (bytes >= BYTES_IN_KB) return `${(bytes / BYTES_IN_KB).toFixed(2)} KB`;
//     return `${bytes} bytes`;
//   };

//   const formatTotalSpace = (gb) => {
//     return isUnlimited ? "Unlimited" : `${gb} GB`;
//   };

//   return (
//     <Box sx={{ width: "100%", p: 2 }}>
//       <Box display="flex" justifyContent="space-between" mb={1}>
//         <Typography variant="body2" color="text.secondary">
//           {formatStorage(fsUserProfile.usedSpace)} of{" "}
//           {formatTotalSpace(TOTAL_SPACE_GB)} used
//         </Typography>
//         {!isUnlimited && (
//           <Typography variant="body2" color="text.secondary">
//             {percentageUsed.toFixed(2)}%
//           </Typography>
//         )}
//       </Box>

//       {!isUnlimited && (
//         <LinearProgress
//           variant="determinate"
//           value={percentageUsed}
//           sx={{
//             height: 8,
//             borderRadius: 4,
//             "& .MuiLinearProgress-bar": {
//               borderRadius: 4,
//               backgroundColor:
//                 percentageUsed > 90 ? "error.main" : "primary.main",
//             },
//           }}
//         />
//       )}
//     </Box>
//   );
// };

// export default StorageUsageWidget;

// free plan or dynamic paln
import { Box, LinearProgress, Typography } from "@mui/material";

const StorageUsageWidget = ({ userTotalSpacePlan, fsUserProfile }) => {
  if (!fsUserProfile || !fsUserProfile.usedSpace) {
    return null;
  }

  const BYTES_IN_GB = 1073741824;
  const BYTES_IN_MB = 1048576;
  const BYTES_IN_KB = 1024;

  // Format bytes to readable string
  const formatStorage = (bytes) => {
    if (bytes >= BYTES_IN_GB) return `${(bytes / BYTES_IN_GB).toFixed(2)} GB`;
    if (bytes >= BYTES_IN_MB) return `${(bytes / BYTES_IN_MB).toFixed(2)} MB`;
    if (bytes >= BYTES_IN_KB) return `${(bytes / BYTES_IN_KB).toFixed(2)} KB`;
    return `${bytes} bytes`;
  };

  // Default values for free plan
  let totalSpace = 5; // Default 5 GB
  let isUnlimited = false;
  let percentageUsed =
    (fsUserProfile.usedSpace / (totalSpace * BYTES_IN_GB)) * 100;
  let unit = "GB";

  // If user has a plan, override with dynamic values
  if (userTotalSpacePlan) {
    const noOfAllowed = userTotalSpacePlan.noOfAllowed ?? 0;
    const format = userTotalSpacePlan.format ?? "GB";
    isUnlimited = userTotalSpacePlan.isUnlimited ?? false;

    if (!isUnlimited) {
      if (format === "TB") {
        totalSpace = noOfAllowed * 1024;
        percentageUsed =
          (fsUserProfile.usedSpace / BYTES_IN_GB / totalSpace) * 100;
        unit = "GB";
      } else if (format === "GB") {
        totalSpace = noOfAllowed;
        percentageUsed =
          (fsUserProfile.usedSpace / BYTES_IN_GB / totalSpace) * 100;
        unit = "GB";
      } else if (format === "MB") {
        totalSpace = noOfAllowed;
        percentageUsed =
          (fsUserProfile.usedSpace / BYTES_IN_MB / totalSpace) * 100;
        unit = "MB";
      }
    }
  }

  const formatTotalSpace = (value) =>
    isUnlimited ? "Unlimited" : `${value} ${unit}`;

  return (
    <Box sx={{ width: "100%", p: 2 }}>
      <Box display="flex" justifyContent="space-between" mb={1}>
        <Typography variant="body2" color="text.secondary">
          {formatStorage(fsUserProfile.usedSpace)} of{" "}
          {formatTotalSpace(totalSpace)} used
        </Typography>
        {!isUnlimited && (
          <Typography variant="body2" color="text.secondary">
            {percentageUsed.toFixed(2)}%
          </Typography>
        )}
      </Box>

      {!isUnlimited && (
        <LinearProgress
          variant="determinate"
          value={percentageUsed}
          sx={{
            height: 8,
            borderRadius: 4,
            "& .MuiLinearProgress-bar": {
              borderRadius: 4,
              backgroundColor:
                percentageUsed > 90 ? "error.main" : "primary.main",
            },
          }}
        />
      )}
    </Box>
  );
};

export default StorageUsageWidget;
